<template>
  <div>
    <el-row>
      <el-tabs class="tab-button">
        <el-tab-pane label="트랩 설정">
          <w-trap-detail-form ref="trapDetail" :selected-row="selectedRow"
          @update-trap-inform="updateTrapInform" />
        </el-tab-pane>
        <el-tab-pane label="OID 설정">
          <w-trap-event-table :selected-row="selectedRow" />
        </el-tab-pane>
      </el-tabs>
    </el-row>
  </div>
</template>

<script>
import WTrapDetailForm from './TrapDetailForm';
import WTrapEventTable from './TrapEventTable';

export default {
  name: 'WTrapInformation',
  components: {
    WTrapDetailForm,
    WTrapEventTable,
  },
  props: {
    selectedRow: {
      type: Object,
    },
  },
  data() {
    return {
      selectedEvent: {},
      selectedSuboid: {},
    };
  },
  methods: {
    updateTrapInform() {
      this.$emit('update-trap-inform');
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log/SnmpTrap/components/TrapInformation.vue